<template>
  <v-btn
    class="frame-button"
    variant="flat"
    color="white">
    <div
      class="mr-2"
      :style="`
        border-radius: 50%;
        width: 12px;
        height: 12px;
        color: white !important;
        background: ${color};
      `"></div>
    {{ name }}
  </v-btn>
</template>
<script setup>
const props = defineProps(['name', 'color']);
</script>
<style></style>
